import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import EvaluateCompaniesCheckEmail from './EvaluateCompaniesCheckEmail';
import EvaluateCompaniesForm from './EvaluateCompaniesForm';

export default function EvaluateCompanies(props) {
    const [emailChecked, setEmailChecked] = useState(localStorage.getItem('emailChecked') && localStorage.getItem('emailChecked') === '1');

    useEffect(() => {
        localStorage.setItem('emailChecked', emailChecked ? '1' : '0');
    }, [emailChecked]);

    return (
        <div className={emailChecked ? 'container-fluid' : 'container'}>
            <a className="logo d-block text-center my-3" href={mainUrl}>
                <img src={logo} />
            </a>
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="card border-0 rounded-15px bg-white shadow h-100" style={{ minHeight: '300px' }}>
                        <div className="card-body">
                            {emailChecked && (
                                <EvaluateCompaniesForm
                                    saveUrl={props.saveUrl}
                                    submitUrl={props.submitUrl}
                                    checkEmailUrl={props.checkEmailUrl}
                                    fetchUrl={props.fetchUrl}
                                />
                            )}
                            {!emailChecked && <EvaluateCompaniesCheckEmail checkEmailUrl={props.checkEmailUrl} setEmailChecked={setEmailChecked} />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

if (document.getElementById('evaluateCompanies')) {
    ReactDOM.render(
        <App>
            <EvaluateCompanies saveUrl={saveUrl} submitUrl={submitUrl} checkEmailUrl={checkEmailUrl} fetchUrl={fetchUrl} logo={logo} mainUrl={mainUrl} />
        </App>,
        document.getElementById('evaluateCompanies'),
    );
}
